var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6337",
    "data-name": "Rectangle 6337",
    width: 36.479,
    height: 40.384,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34944",
    "data-name": "Group 34944",
    transform: "translate(-4283 -5404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6339",
    "data-name": "Rectangle 6339",
    transform: "translate(4283 5404)",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34889",
    "data-name": "Group 34889",
    transform: "translate(4302 5421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34888",
    "data-name": "Group 34888",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24425",
    "data-name": "Path 24425",
    d: "M33.247,37.127c.438,0,.843,0,1.249,0a1.953,1.953,0,0,1,1.979,1.952c.029,1.21-.062,1.3-1.261,1.3H1.018C.16,40.384,0,40.224,0,39.366a1.988,1.988,0,0,1,2.222-2.239h1V5.884a5.437,5.437,0,0,1-.589-.05,1.626,1.626,0,0,1,.318-3.225c2.5-.007,4.993,0,7.49,0h.626c0-.594,0-1.172,0-1.749,0-.64.215-.856.853-.856Q17.91,0,23.895,0c.639,0,.854.216.856.853,0,.567,0,1.135,0,1.752h.461q4.153,0,8.3,0a1.626,1.626,0,0,1,.323,3.224,5.094,5.094,0,0,1-.593.047ZM9.77,37.106v-.468q0-3.215,0-6.431c0-.694.2-.9.9-.9H25.808c.694,0,.9.2.9.894q0,3.237,0,6.472v.43h5.187V5.891H4.579V37.106ZM35.148,39.06c-.1-.513-.265-.63-.872-.63H2.209a1.774,1.774,0,0,0-.324.008.61.61,0,0,0-.563.622ZM18.24,4.56q7.488,0,14.975,0c.256,0,.622.1.634-.3.014-.44-.37-.341-.637-.341q-14.975-.005-29.949,0c-.259,0-.625-.085-.637.306-.014.432.371.341.64.341q7.487,0,14.975,0M11.087,37.095h2.57V30.639h-2.57Zm6.471-6.448H15v6.462h2.556Zm1.36,6.448h2.556V30.632H18.918Zm3.908,0h2.555V30.631H22.826ZM12.395,2.577H23.416V1.324H12.395Z",
    transform: "translate(0 0)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24426",
    "data-name": "Path 24426",
    d: "M18.882,30.864H8.708a1.977,1.977,0,0,1-2.185-2.195q0-2.421,0-4.843a1.955,1.955,0,0,1,2.094-2.08H29.17a1.957,1.957,0,0,1,2.1,2.112q0,2.463,0,4.925a1.955,1.955,0,0,1-2.094,2.081q-5.148,0-10.3,0m.015-1.3q5.109,0,10.218,0c.638,0,.855-.217.856-.854q0-2.4,0-4.8c0-.639-.217-.855-.856-.855H8.681c-.64,0-.854.215-.855.854q0,2.36,0,4.722c0,.749.189.937.936.937H18.9",
    transform: "translate(-0.661 -2.203)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24427",
    "data-name": "Path 24427",
    d: "M21.019,9.853c0-.61,0-1.221,0-1.832,0-.533.238-.77.771-.772q1.832-.008,3.663,0c.533,0,.771.239.773.771q.008,1.832,0,3.663c0,.532-.241.771-.772.773q-1.831.008-3.663,0c-.532,0-.767-.24-.772-.772-.006-.61,0-1.221,0-1.832m3.876-1.282H22.346v2.569h2.549Z",
    transform: "translate(-2.13 -0.734)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24428",
    "data-name": "Path 24428",
    d: "M30.848,12.458c-.61,0-1.221.005-1.832,0a.664.664,0,0,1-.748-.756q-.008-1.851,0-3.7a.661.661,0,0,1,.755-.748q1.852-.008,3.7,0A.662.662,0,0,1,33.475,8q.008,1.852,0,3.7a.664.664,0,0,1-.756.749c-.624.007-1.248,0-1.872,0m1.3-3.881H29.6v2.56h2.553Z",
    transform: "translate(-2.864 -0.734)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24429",
    "data-name": "Path 24429",
    d: "M6.523,17.1c0-.61,0-1.221,0-1.832,0-.533.239-.77.771-.772q1.832-.008,3.664,0c.532,0,.77.239.773.771q.007,1.832,0,3.663c0,.532-.242.771-.772.773q-1.832.008-3.664,0c-.532,0-.767-.24-.772-.772-.006-.61,0-1.221,0-1.832M10.4,15.826H7.856V18.4H10.4Z",
    transform: "translate(-0.661 -1.469)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24430",
    "data-name": "Path 24430",
    d: "M16.35,19.706c-.61,0-1.221.005-1.832,0a.664.664,0,0,1-.746-.757q-.008-1.852,0-3.7a.66.66,0,0,1,.757-.746q1.852-.008,3.7,0a.661.661,0,0,1,.747.756q.008,1.852,0,3.7a.664.664,0,0,1-.757.747c-.625.007-1.248,0-1.873,0M15.1,18.375h2.549V15.806H15.1Z",
    transform: "translate(-1.395 -1.469)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24431",
    "data-name": "Path 24431",
    d: "M23.6,19.706c-.61,0-1.221.005-1.832,0a.664.664,0,0,1-.746-.757q-.008-1.852,0-3.7a.66.66,0,0,1,.757-.746q1.851-.008,3.7,0a.661.661,0,0,1,.747.756q.008,1.852,0,3.7a.664.664,0,0,1-.757.747c-.625.007-1.248,0-1.873,0m1.308-3.881H22.351v2.559h2.555Z",
    transform: "translate(-2.129 -1.469)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24432",
    "data-name": "Path 24432",
    d: "M30.872,14.5c.61,0,1.221,0,1.831,0,.532.005.77.241.772.773q.008,1.832,0,3.663c0,.531-.241.77-.773.772q-1.831.008-3.663,0c-.532,0-.769-.24-.771-.773q-.008-1.832,0-3.663c0-.533.239-.767.772-.772.61-.005,1.221,0,1.832,0m1.271,1.324H29.594v2.569h2.549Z",
    transform: "translate(-2.864 -1.469)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24433",
    "data-name": "Path 24433",
    d: "M16.336,12.458c-.6,0-1.193,0-1.791,0-.532-.005-.77-.241-.772-.772q-.008-1.832,0-3.664c0-.533.238-.77.771-.772q1.831-.008,3.663,0c.532,0,.771.239.773.77q.008,1.832,0,3.664c0,.532-.241.768-.771.774-.625.005-1.248,0-1.873,0M15.1,11.129h2.553V8.569H15.1Z",
    transform: "translate(-1.395 -0.734)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24434",
    "data-name": "Path 24434",
    d: "M11.733,9.853c0,.61,0,1.221,0,1.832-.005.531-.242.77-.773.772q-1.832.008-3.664,0c-.531,0-.769-.24-.771-.773q-.007-1.831,0-3.663c0-.533.239-.769.772-.771q1.832-.008,3.663,0c.532,0,.767.24.773.772.005.61,0,1.221,0,1.832M7.844,11.135h2.563V8.58H7.844Z",
    transform: "translate(-0.661 -0.734)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24435",
    "data-name": "Path 24435",
    d: "M12.58,29.112H11.316V27.206H10.008v1.905H8.73V23.945H9.993v1.9H11.3V23.94H12.58Z",
    transform: "translate(-0.885 -2.426)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24436",
    "data-name": "Path 24436",
    d: "M27.165,25.882V27.16h-1.92v.655h1.9v1.3c-.885,0-1.776.022-2.664-.01a.583.583,0,0,1-.558-.64c-.008-1.3-.01-2.6,0-3.9a.592.592,0,0,1,.608-.636c.865-.022,1.73-.007,2.619-.007v1.29h-1.9v.67Z",
    transform: "translate(-2.423 -2.424)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24437",
    "data-name": "Path 24437",
    d: "M17.676,26.539c0,.23.007.461,0,.691a1.951,1.951,0,0,1-3.9.011c-.015-.474-.014-.949,0-1.423a1.951,1.951,0,0,1,3.9-.012c.009.244,0,.488,0,.732m-1.3.01c0-.231.013-.462,0-.692a.644.644,0,0,0-.662-.632.633.633,0,0,0-.627.623c-.019.447-.019.9,0,1.343a.637.637,0,0,0,.66.634.646.646,0,0,0,.63-.625c.016-.216,0-.433,0-.651",
    transform: "translate(-1.395 -2.424)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24438",
    "data-name": "Path 24438",
    d: "M20.145,29.1V25.241H18.881v-1.29H22.73V25.21H21.475V29.1Z",
    transform: "translate(-1.913 -2.427)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24439",
    "data-name": "Path 24439",
    d: "M29.556,27.837H31.5v1.3h-.907c-.542,0-1.084.007-1.625,0a.636.636,0,0,1-.7-.676c-.01-1.489,0-2.978,0-4.5h1.288Z",
    transform: "translate(-2.864 -2.427)",
    fill: "#353841"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.c32fbe408c6d81daebbce60d6052ee85.svg";
export { ForwardRef as ReactComponent };